var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudsBgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 31,
    viewBox: "0 0 346 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173,
    cy: 15.5,
    rx: 173,
    ry: 15.5,
    fill: "#EEF6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsBgShadow);
export default __webpack_public_path__ + "static/media/clouds-bg-shadow.7901d6323cfbacb162b368b1f4486c29.svg";
export { ForwardRef as ReactComponent };